import React from 'react';

import Tab from './Tab';

export default function Tabs({ tabs = [], currentTab }) {
  return (
    <ul className="relative text-sm font-medium flex flex-nowrap -mx-4 sm:-mx-6 lg:-mx-8 overflow-x-scroll no-scrollbar z-40">
      {tabs
        .filter((tab) => !tab.isHidden)
        .map((tab) => (
          <Tab
            key={tab.label}
            label={tab.label}
            displayLabel={tab.displayLabel}
            isActive={
              tab.active ||
              tab.label === currentTab ||
              tab.activeOn === currentTab ||
              tab.activeOn?.includes?.(currentTab)
            }
            // eslint-disable-next-line react/jsx-handler-names
            onClick={tab.onClick}
          />
        ))}
    </ul>
  );
}
